<mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>{{'importer.day-type' | translate | capitalizeFirst}}</mat-label>
    <button mat-icon-button matSuffix type="button" aria-label="Clear selection" [disabled]="disabled"
        (click)="onSelectChange(null); $event.stopPropagation()">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
    <mat-select [value]="value" (selectionChange)="onSelectChange($event.value)" [disabled]="disabled" multiple>
        <mat-option *ngFor="let day of availableDaytypes" [value]="getOptionValue(day)">
            {{ day.description }}
        </mat-option>
    </mat-select>
</mat-form-field>